// extracted by mini-css-extract-plugin
export default {"root":"SummaryWrap_root__1y1VA","placeHolderShimmer":"SummaryWrap_placeHolderShimmer__PQlH6"};